module.exports = __webpack_public_path__ + "img/headphoto.a651ccde.jpg";